import { stage } from 'config/stage';

const config = {
    prd: {
        name: 'NEXT Cloud Login',
        host: 'https://login.nextcloud.aero',
        latestVersion: 10,
    },
    test: {
        name: 'NEXT Cloud Login',
        host: 'https://login-test.nextcloud.aero',
        latestVersion: 10,
    },
    dev: {
        name: 'NEXT Cloud Login',
        host: 'https://login-dev.nextcloud.aero',
        latestVersion: 10,
    },
    cloud9: {
        name: 'NEXT Cloud Login',
        host: process.env.REACT_APP_HOST,
        latestVersion: 14,
    },
    ide: {
        name: 'NEXT Cloud Login',
        host: process.env.REACT_APP_HOST,
        latestVersion: 13,
    },
};

export default config[stage];
